import { getEnvVar } from '@utils/get-env-var';

const validateEmailRegex =
    /^[a-zA-Z0-9._-]+(\+test[0-9]*){0,1}@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const testEmailRegex =
    /^[a-zA-Z0-9._-]+(\+test[0-9]*){1}@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const validateEmailRegexStage =
    /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const validateEmail = (string: string) =>
    ['development', 'local'].includes(getEnvVar('REACT_APP_TYPE') || '')
        ? validateEmailRegexStage.test(string)
        : validateEmailRegex.test(string);

export type Statuses = {
    length?: boolean;
    lowerCase?: boolean;
    upperCase?: boolean;
    digit?: boolean;
    symbols?: boolean;
};

export const isTestEmail = (email: string): boolean => testEmailRegex.test(email);

export const validatePassword = (string: string) => {
    const statuses: Statuses = {
        length: false,
        lowerCase: false,
        upperCase: false,
        digit: false,
        symbols: false,
    };

    const lowerCaseRegex = /.*[a-z].*/;
    const upperCaseRegex = /.*[A-Z].*/;
    const digitRegex = /.*[0-9].*/;
    const symbolsRegex = /.*[!@#$%^&*|\\/=_-].*/;

    statuses.length = string.length >= 8 && string.length <= 54;
    statuses.lowerCase = lowerCaseRegex.test(string);
    statuses.upperCase = upperCaseRegex.test(string);
    statuses.digit = digitRegex.test(string);
    statuses.symbols = symbolsRegex.test(string);

    const isPasswordValid = Object.values(statuses).every((check) => check);

    return {
        isPasswordValid,
        statuses,
    };
};

export const getAuthConfirmPasswordError = (password: string, passwordNew: string) => {
    const { isPasswordValid } = validatePassword(password);
    const isError = isPasswordValid && passwordNew !== password && !!passwordNew?.length;

    return isError;
};
